import { createSlice } from '@reduxjs/toolkit'

import { RootState } from '..'
import {
  fetchBusDriverSignOnsAction,
  fetchBusDriverSignOnsAllowedAction,
} from '../actions/bus-driver-sign-ons'
import { ActionStatus, BusDriverSignOn } from '../types/Input'

export interface BusDriverSignOnsState {
  status: ActionStatus
  signOns: BusDriverSignOn[]
  canReadSignOns: boolean
  error?: string
}

const initialState: BusDriverSignOnsState = {
  status: 'none',
  signOns: [],
  canReadSignOns: false,
}

export const busDriverSignOnsSlice = createSlice({
  name: 'bus-driver-sign-ons',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBusDriverSignOnsAction.pending, (state) => {
      state.status = 'loading'
      state.error = undefined
    })

    builder.addCase(fetchBusDriverSignOnsAction.fulfilled, (state, { payload }) => {
      state.signOns = payload
      state.status = 'succeeded'
    })

    builder.addCase(fetchBusDriverSignOnsAction.rejected, (state, { payload }) => {
      state.error = payload?.message ?? 'Failed to fetch bus driver sign-ons'
      state.status = 'failed'
    })

    builder.addCase(fetchBusDriverSignOnsAllowedAction.fulfilled, (state, { payload }) => {
      state.canReadSignOns = payload
    })
  },
})

export default busDriverSignOnsSlice.reducer

export const selectBusDriverSignOns = (state: RootState) => state.busDriverSignOns.signOns

export const selectBusDriverSignOnsStatus = (state: RootState) => state.busDriverSignOns.status

export const selectBusDriverSignOnsError = (state: RootState) => state.busDriverSignOns.error

export const selectCanReadBusDriverSignOns = (state: RootState) =>
  state.busDriverSignOns.canReadSignOns
